import { Component, input } from '@angular/core';
import { getUaDevice } from '@context/frontend/native/platform';
import { Organization } from '@context/shared/types/organization';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon } from '@taiga-ui/core';

@Component({
	standalone: true,
	imports: [TuiIcon, TranslocoModule],
	selector: 'ctx-organization-row',
	templateUrl: 'organization-row.component.html',
	styleUrl: 'organization-row.component.scss',
	host: {
		'[attr.device]': 'device',
		'[attr.size]': 'size()',
	},
})
export class OrganizationRowComponent {
	readonly device = getUaDevice();

	readonly organization = input.required<Organization>();

	readonly interactable = input(true);

	readonly size = input<'s' | 'm'>('m');
}
